import { ability } from './ability'

export function initAbilityFromStorage() {
  try {
    const raw = localStorage.getItem('userAbilities')
    if (raw) {
      const rules = JSON.parse(raw)
      ability.update(rules)
    }
  } catch (error) {
    console.error('[CASL] Failed to initialize ability from storage:', error)
  }
}

export function saveAbilityToStorage() {
  localStorage.setItem('userAbilityRules', JSON.stringify(ability.rules))
}